import Switch from './switch';
import mapProp from '../scripts/utils/map-props';

export default mapProp(
  [
    'checked',
  ],
  {
    model: {
      prop: 'checked',
      event: 'change',
    },
  }
)(Switch);
